import { z } from "zod";
import { claiminiIdSchema } from "../../zod/claiminiId.js";
// Completion outcomes only — skipping is a separate action (POST /tasks/incident-report/skip)
// that resets the step instead of writing a result.
export const incidentReportProcessingStatus = {
    PROCESSED: "processed",
    PROCESSED_WITH_HELP: "processed_with_help",
};
// Shared base: the fields the claimini-gateway provides. Extended by `createIncidentReportTaskSchema`
// (adds `priority`, `channel` and `service`) and by the stored step input (adds `service` and `skipHandoffs`).
export const incidentReportProcessingInputSchema = z.object({
    incidentClaiminiId: claiminiIdSchema,
    customerClaiminiId: claiminiIdSchema.optional(),
    customerDisplayName: z.string().min(1).max(500),
    description: z.string().min(1).max(10000),
    // claimini-adapter may send offset-bearing timestamps (e.g. +02:00), not only Z-suffixed UTC.
    reportedAt: z.iso.datetime({ offset: true }),
});
// Single source of truth for the comment bound — shared by the result schema, the skip
// endpoint's request schema, and the web form's client-side validation.
export const INCIDENT_REPORT_COMMENT_MAX_LENGTH = 5000;
// One entry per skip: who released the task back to the pool and (optionally) why. Appended to
// `step.input.skipHandoffs` so the next assignee sees prior context — never part of the result.
export const incidentReportSkipHandoffSchema = z.object({
    userId: z.uuid(),
    displayName: z.string().min(1).max(300),
    comment: z.string().max(INCIDENT_REPORT_COMMENT_MAX_LENGTH).optional(),
    skippedAt: z.iso.datetime(),
});
// eClaim's service of the incident, raw. Validated as a non-empty string, not an enum, so a new eClaim
// value cannot reject an incident report.
export const incidentReportServiceSchema = z.string().min(1);
// The persisted step input: claimini-gateway fields plus the accumulating skip-handoff log. `service` is
// optional because step inputs written before the gateway sent it lack it. Make it required once the
// incident report backfill has written it into every old step input.
export const incidentReportProcessingStoredInputSchema = incidentReportProcessingInputSchema.extend({
    service: incidentReportServiceSchema.optional(),
    skipHandoffs: z.array(incidentReportSkipHandoffSchema).optional(),
});
export const incidentReportProcessingResultSchema = z.object({
    status: z.enum([incidentReportProcessingStatus.PROCESSED, incidentReportProcessingStatus.PROCESSED_WITH_HELP]),
    comment: z.string().max(INCIDENT_REPORT_COMMENT_MAX_LENGTH).optional(),
});
